import { render, staticRenderFns } from "./AreaContent.vue?vue&type=template&id=4f398ef0"
import script from "./AreaContent.vue?vue&type=script&lang=js"
export * from "./AreaContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports